<div class="full-page-center">
  <div class="card">
    <div class="card-body">
        <div class="title-container">
                <h4 class="form-title">Ajouter un prêt en espèces</h4>
                <h4 class="text-muted mb-4">Client : {{ client.lastName }} {{ client.firstName }}</h4>
        </div>
  
      <form  autocomplete="off">
        <div class="mb-3">
          <label for="amount" class="form-label">Montant</label>
          <div class="price-wrapper">
            <span class="currency-label">MAD</span>
            <input
              type="number"
              class="form-control-plaintext price-display"
              [(ngModel)]="loan.amount"
              name="amount"
              required
              placeholder="Montant du prêt"
            />
          </div>
        </div>

        <div class="mb-3">
          <label for="advancePayment" class="form-label">Avance</label>
          <div class="price-wrapper">
            <span class="currency-label">MAD</span>
            <input
              type="number"
              class="form-control-plaintext price-display"
              [(ngModel)]="loan.advancePayment"
              name="advancePayment"
              placeholder="Montant avancé"
            />
          </div>
        </div>

        <div class="checkbox-parent">
          <div class="checkbox-wrapper-3">
            <input type="checkbox" [(ngModel)]="loan.isPaid" name="isPaid" id="cbx-3" />
            <label for="cbx-3" class="toggle"><span></span></label>
          </div>
          <label for="cbx-3" class="text-muted accept-payment">Le prêt est payé</label>
        </div>

        <div class="mb-3">
          <label for="note" class="form-label">Note</label>
          <textarea
            class="form-control"
            [(ngModel)]="loan.note"
            name="note"
            rows="3"
            placeholder="Ajouter une note (facultatif)"
          ></textarea>
        </div>

        <div class="input-avance-container">
          <div class="avance-input">
            <input *ngIf="!loanId" type="submit" class="btn btn-primary" value="Valider" (click)="submitLoan()">
            <input *ngIf="loanId" type="submit" class="btn btn-primary" value="Modifier" (click)="submitLoan()">
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
